export const SearchParam = (() => {
	const _name = Symbol();
	const _value = Symbol();

	class SearchParam {
		constructor(name, value) {
			if(typeof name !== 'string')
				throw new TypeError('name must be a string.');
			if(typeof value !== 'string')
				throw new TypeError('value must be a string');
			this[_name] = name;
			this[_value] = value;
		}
		get name() {
			return this[_name];
		}
		get value() {
			return this[_value];
		}
		toJSON() {
			return {
				name: this.name,
				value: this.value
			};
		}
		toString() {
			return `${this.name}=${this.value}`;
		}
		static fromString(str) {
			if(typeof str !== 'string')
				throw new TypeError('str must be a string');
			const [name, value] = str.split('=');
			return new this(
				name,
				value
			);
		}
	}
	return SearchParam;
})();
export const SearchParams = (() => {
	const _items = Symbol();
	class SearchParams {
		constructor(...items) {
			this[_items] = [];

			this.add(...items);
		}
		add(...items) {
			items.forEach((v, index) => {
				if(!(v instanceof SearchParam))
					throw new TypeError(`value at index ${index} must be an instance of SearchParam.`);
			});
			this[_items].push(...items);
		}
		//iterator protocol support
		*iterator() {
			for(let key in this[_items]) {
				let value = this[_items][key];
				yield value;
			}
		}
		//iterable protocol support
		[Symbol.iterator]() {
			return this.iterator();
		}
		toString() {
			return this[_items].map(v => `${v.name}=${v.value}`).join('&');
		}
		toJSON() {
			const obj = {};
			this[_items].forEach(v => obj[v.name] = v.value);
			return obj;
		}
		static fromString(str) {
			if(typeof str !== 'string')
				throw new TypeError('str must be a string.');
			let _str = str.match(/^\??(.*)$/)[1];
			return new this(
				..._str.split('&').map(v => SearchParam.fromString(v))
			);
		}
	}
	return SearchParams;
})();